import VerifyEmailErrorContainer from "../containers/VerifyEmailErrorContainer";

const VerifyEmailErrorPage = () => {
  return <VerifyEmailErrorContainer />;
};

export default VerifyEmailErrorPage;
